(() => {
  if (customElements.get('nd-product-offers')) {
    return;
  }

  class NeedledustProductOffers extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') {
        return;
      }

      this.dataset.initialized = 'true';
      this.viewport = this.querySelector('[data-offer-viewport]');
      this.slides = [...this.querySelectorAll('[data-offer-slide]')];
      this.dots = [...this.querySelectorAll('[data-offer-dot]')];
      this.currentIndex = 0;

      if (!this.viewport || this.slides.length < 2) {
        return;
      }

      this.querySelector('[data-offer-previous]')?.addEventListener('click', () => this.goTo(this.currentIndex - 1, true));
      this.querySelector('[data-offer-next]')?.addEventListener('click', () => this.goTo(this.currentIndex + 1, true));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.offerDot), true)));

      this.viewport.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
      this.addEventListener('pointerdown', () => this.stopAutoplay(), { passive: true });
      this.addEventListener('pointerup', () => this.startAutoplay(), { passive: true });
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      this.updateState();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    handleVisibilityChange = () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    };

    onScroll() {
      window.clearTimeout(this.scrollTimer);
      this.scrollTimer = window.setTimeout(() => {
        const nextIndex = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
        this.currentIndex = Math.max(0, Math.min(nextIndex, this.slides.length - 1));
        this.updateState();
      }, 80);
    }

    goTo(index, restartAutoplay = false) {
      const wrappedIndex = (index + this.slides.length) % this.slides.length;
      this.currentIndex = wrappedIndex;
      this.viewport.scrollTo({ left: this.viewport.clientWidth * wrappedIndex, behavior: 'smooth' });
      this.updateState();

      if (restartAutoplay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    updateState() {
      this.slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== this.currentIndex)));
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.currentIndex)));
    }

    startAutoplay() {
      if (this.dataset.autoplay !== 'true' || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      const delay = Math.max(3, Number(this.dataset.cycleSeconds) || 5) * 1000;
      this.stopAutoplay();
      this.autoplayTimer = window.setInterval(() => this.goTo(this.currentIndex + 1), delay);
    }

    stopAutoplay() {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  customElements.define('nd-product-offers', NeedledustProductOffers);
})();
